import Box from '@mui/material/Box';

import styles from '@/styles/job-details-card.module.css';
import { Job } from '@/types/job';
import Link from '@/components/link-with-utms';
import JobDetailsCardContent from './job-details-card-content';
import JobDetailsCardHeader from './job-details-card-header';

interface Props {
  titleWithH1?: boolean;
  className?: string;
  job: Job;
  linkToSearch?: boolean;
  linkToDetails?: boolean;
}

export function ContainerLinkDetails({
  job,
  children,
  linkToDetails = false,
}: {
  job: Job;
  children: React.ReactNode;
  linkToDetails?: boolean;
}) {
  if (linkToDetails) {
    return (
      <Link href={`/vagas/emprego/${job.id}-vaga-de-${job.roleSlug}`} className={styles.link_details}>
        {children}
      </Link>
    );
  }
  return <Box>{children}</Box>;
}

export default function JobDetailsCard({ titleWithH1, className, job, linkToSearch, linkToDetails }: Props) {
  return (
    <Box className={`${styles.job_details_card} ${className}`}>
      <JobDetailsCardHeader
        job={job}
        showShareButton
        linkToSearch={linkToSearch}
        linkToDetails={linkToDetails}
        titleWithH1={titleWithH1}
      />
      <JobDetailsCardContent job={job} linkToDetails={linkToDetails} />
    </Box>
  );
}
